export default __webpack_public_path__ + "static/media/pic7.a8aefa7a.jpg";